<template>
  <div
    v-if="savedSearches && savedSearches.length"
    class="filters-saved-searches"
    aria-label="Збережені пошуки"
  >
    <h5 class="filters-saved-searches__label">Збережені пошуки:</h5>

    <div class="filters-saved-searches__slider-wrap">
      <div class="swiper" ref="mainSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="search in savedSearches"
            :key="search.id"
          >
            <div class="filters-saved-searches__tag">
              <span
                class="filters-saved-searches__tag-text"
                :aria-label="`Застосувати пошук: ${search.label}`"
                @click.prevent="applySearch(search)"
              >
                {{ search.label }}
              </span>

              <button
                type="button"
                class="filters-saved-searches__tag-remove"
                :aria-label="`Видалити пошук: ${search.label}`"
                @click.prevent="removeSearch(search.id)"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div class="swiper-scrollbar" aria-hidden="true"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default {
  name: 'SavedSearchTags',
  props: {
    savedSearches: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mainSwiperInstance: null
    };
  },
  watch: {
    savedSearches: {
      handler() {
        this.$nextTick(() => this.updateSwiper());
      },
      deep: true
    }
  },
  mounted() {
    this.updateSwiper();
  },
  beforeDestroy() {
    this.destroySwiper();
  },
  methods: {
    applySearch(search) {
      this.$emit('apply-search', search);
    },
    removeSearch(id) {
      this.$emit('remove-search', id);
    },
    initSwiper() {
      if (!this.$refs.mainSwiper || this.mainSwiperInstance) return;

      this.mainSwiperInstance = new Swiper(this.$refs.mainSwiper, {
        modules: [Scrollbar, Mousewheel],
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 8,
        speed: 400,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        mousewheel: {
          enabled: true,
          releaseOnEdges: true
        }
      });
    },
    updateSwiper() {
      if (!this.savedSearches.length) {
        this.destroySwiper();
        return;
      }

      this.$nextTick(() => {
        if (!this.mainSwiperInstance) {
          this.initSwiper();
        } else {
          this.mainSwiperInstance.update();
        }
      });
    },
    destroySwiper() {
      if (this.mainSwiperInstance) {
        this.mainSwiperInstance.destroy(true, true);
        this.mainSwiperInstance = null;
      }
    }
  }
};
</script>

<style lang="sass">
.filters-saved-searches
  padding: 0.5rem

  &__label
    font-size: 0.75rem
    font-weight: 500
    line-height: 1.2

    &:not(:last-child)
      margin-bottom: 0.25rem

  &__slider-wrap
    --swiper-scrollbar-bottom: 0

    position: relative
    min-width: 0

    .swiper
      overflow: hidden

      @include hover
        .swiper-scrollbar
          opacity: 1

      .swiper-wrapper
        padding-bottom: 0.5rem

      .swiper-slide
        width: auto

      .swiper-scrollbar
        opacity: 0
        transition: opacity var(--transition-duration-primary)

  &__tag
    --tag-height: 1.375rem
    --tag-padding-x: 0.5rem
    --tag-remove-size: 1.375rem

    display: flex
    align-items: center
    gap: 0.5rem
    border-radius: var(--tag-height)
    min-height: var(--tag-height)
    padding: 0 var(--tag-padding-x)
    padding-right: 0
    background-color: var(--color-easy-mint)
    color: var(--color-white)
    font-size: 0.75rem
    font-weight: 600
    line-height: 1
    text-wrap: nowrap

    &:not(:disabled)
      cursor: pointer

    &-remove
      display: flex
      align-items: center
      justify-content: center
      border: none
      border-radius: 0 var(--tag-height) var(--tag-height) 0
      flex: 0 0 var(--tag-remove-size)
      width: var(--tag-remove-size)
      height: var(--tag-remove-size)
      background: none
      font-size: calc(var(--tag-remove-size) * 0.75)
      font-weight: 400
      line-height: 1
      color: inherit
      transition: background-color var(--transition-duration-primary)

      &:hover
        background-color: var(--color-havasupai-falls)
</style>
